<template>
    <div style="text-align: center; ">
        <div>
            <div style="margin-top: 16px;">
                <div>
                    <input v-model="recommend_code" @input="detectText" class="common_input" placeholder="추천인 코드를 입력하세요(선택)" type="text">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { REGIST_STEP } from '@/Constants';

export default {
    name: 'SignupRecommend',
    props: {
        detectText: {
            type: Function,
            default: () => { }
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => {}
        },
        setActiveBtn: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            recommend_code: '',
        }
    },
    methods: {

    },
    created() {
        if (this.mode === 'update') {
            this.recommend_code = this.registInfo.recommend_code;
            if (this.name) {
                this.setActiveBtn()
            }
        }
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border-radius: 12px;
    border: none;
    padding: 0 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>